import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["fas", _ctx.inactive ? 'fa-sort' : _ctx.dir === 'asc' ? 'fa-caret-up' : 'fa-caret-down'])
  }, null, 2))
}